export const MAX_CREATIONS_FREE = {
	users: 1,
	jobs: 10,
	candidates: 200,
	clients: 10,
	contacts: 20,
	deals: 10,
	pipelines: 1,
};
